<template >
	
	<v-dialog slot="activator" v-model="dialog" persistent max-width="500">
        <v-btn slot="activator" icon>
        	<v-icon color="grey darken-2">add_circle_outline</v-icon>
        </v-btn>
        <v-card >
        	<v-toolbar><v-toolbar-title>
        		{{items.length>0 ? 'ADD ACCOUNT' : 'NO ACCOUNTS'}}
        	</v-toolbar-title></v-toolbar>
         	<v-card-title class="body-2" color="black">
         		<v-layout column class="pl-1 pt-2">
	         		<v-flex>
	         			<v-layout row>
	         				<v-flex xs2>Dept:</v-flex>
	         				<v-flex>{{deptPCT.deptName}}</v-flex>
	         			</v-layout>
	         		</v-flex>
	         		<v-flex>
	         			<v-layout row>
	         				<v-flex xs2>Room:</v-flex>
	         				<v-flex v-if="room">{{room.number}}</v-flex>
         				</v-layout>
         			</v-flex>
         		</v-layout>
         	</v-card-title> 
        	<v-card-text class="pb-5">
				<v-autocomplete	
					v-if="items.length>0"				 
					autofocus
					:loading="loading"
					:items="items"
					:filter="customFilter"
					v-model="select"
					class=""
					flat
					hide-no-data
					hide-details
					label="Enter Account Number, DeptID, Name"
					solo-inverted
					:readonly="items.length==0 ? true : false"
				>
					<template
				        slot="selection"
				        slot-scope="{ item, tile }"
				      >
				      	<v-layout align-center>
				      		<v-flex xs3 class="px-2">						        
						        	{{item.account}}						       
						    </v-flex>
						    <v-flex xs9>
						        <v-list-tile-content>
						          <v-list-tile-title>
						          	{{item.departmentName}} ({{item.deptID}})
						          </v-list-tile-title>
						          <v-list-tile-sub-title> {{item.description}}
						          	</v-list-tile-sub-title>
						        </v-list-tile-content>
						    </v-flex>
				    	</v-layout>
				      </template>
				      <template
				        slot="item"
				        slot-scope="{ item, tile }"
				      >
				      	<v-layout >
				      		<v-flex xs3 class="px-2">						        
						        	{{item.account}}						       
						    </v-flex>
						    <v-flex xs9>
						        <v-list-tile-content>
						          <v-list-tile-title>
						          	{{item.departmentName}} ({{item.deptID}})
						          </v-list-tile-title>
						          <v-list-tile-sub-title> {{item.description}}
						          	</v-list-tile-sub-title>
						        </v-list-tile-content>
						    </v-flex>
				    	</v-layout>
				      </template>
				</v-autocomplete>
			</v-card-text>
        	<v-card-actions>
	          	<v-spacer></v-spacer>
	          	<v-btn color="green darken-1" flat @click.native="cancel">Cancel</v-btn>
	          	<v-btn v-if="items.length>0" color="green darken-1" flat @click.native="addAccount">Add
	      	 	 </v-btn>
	        </v-card-actions>
    	</v-card>
    </v-dialog>
    
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { AUTH_COOKIE } from '@/store/modules/user'
import { AUTH_API_COOKIE } from '@/store/modules/user'
import jscookie from 'js-cookie'

	export default {
		data: () => ({
			checkbox: false,
			loading: false,
			search: null,
			select: null,
			dialog: false,
			items: [],
		}),

		created: function () {
			this.fetchAccounts().then((data) => {
					this.items = this.sortAccounts(data)
			})
		},


		watch: {
			deptPCT (deptPCT) {
				this.fetchAccounts().then((data) => {
					this.items = this.sortAccounts(data)
					//console.log(this.items)
				})
			},
		},

		props: [ 'deptPCT' ],

		computed: {
				...mapState({ room: state => state.dv.room, }),
		},

		methods: {
			...mapActions(['insertAccount', 'fetchFullRoom', 'fetchAccounts', 'setRoom',]),
			//...mapMutations(['',]),

			customFilter (item, queryText, itemText) {

		        if (queryText.length > 3 ) {
			        return JSON.stringify(item).toLowerCase().indexOf(queryText.toLowerCase()) > -1 
			    }

	    	},			

			addAccount () {
				if (!this.select) { return }
				const payload = { key: this.deptPCT.key, account: this.select.account}
				this.insertAccount(payload)				
				
				// reset and refresh things
				this.$emit('updateLoading', true)
				this.$emit('success')
				this.refreshRoom()
				this.select = null
				this.dialog = false
			},	

			refreshRoom: function () {
				this.fetchFullRoom({bldgAlpha: this.room.bldgAlpha, number: this.room.number, noSet: true}).then((data) => this.setRoom(data) )
			},

			cancel () {
				this.select = null
				this.dialog=false
			},	

			sortAccounts(data) {
				// This makes a new array with the owning department's accounts listed first, then all others.
				let sortedList = []
				data.forEach((obj) => { if (obj.deptID == this.deptPCT.deptID) { sortedList.push(obj) } })
				data.forEach((obj) => { if (obj.deptID != this.deptPCT.deptID) { sortedList.push(obj) } })
				return sortedList
			}

			
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/forms/AddAccount.vue